module.exports = __webpack_public_path__ + "static/media/G1-12-Lorena-Pallas-cod32.fa1b720c.png";